import { useDispatch } from "react-redux";
import { setSnackbar } from "reduxStore/state";
import * as Yup from "yup";
import {
  updateOrganisation,
  createOrganisation,
} from "reduxStore/actions/organisationActions";

export const useOrgForm = ({ editMode, currentOrg, setOpen }) => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Organisation Name is required"),
    description: Yup.string().required("Description is required"),
  });

  const initialValues = {
    name: currentOrg ? currentOrg.name : "",
    description: currentOrg ? currentOrg.description : "",
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      let response;
      if (editMode) {
        response = await dispatch(updateOrganisation(currentOrg._id, values));
      } else {
        response = await dispatch(createOrganisation(values));
      }

      if (response) {
        dispatch(
          setSnackbar({
            open: true,
            message: editMode
              ? "Organisation updated successfully"
              : "Organisation created successfully",
            severity: "success",
          })
        );
        setOpen(false);
      } else {
        dispatch(
          setSnackbar({
            open: true,
            message: "An error occurred",
            severity: "error",
          })
        );
      }
    } catch (error) {
      dispatch(
        setSnackbar({
          open: true,
          message: "An error occurred",
          severity: "error",
        })
      );
    }
  };

  return {
    validationSchema,
    initialValues,
    handleSubmit,
  };
};
